import React from "react";
import { shallowEqual, useSelector } from "react-redux";
import { LoadingDialog } from "../../../../_metronic/_partials/controls";

export function UsersActionsLoadingDialog() {
  const { isLoading } = useSelector(
    (state) => ({ isLoading: state.usersActions.listLoading }),
    shallowEqual
  );

  return <LoadingDialog isLoading={isLoading} />;
}
